import { Injectable} from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PagesService {
  currentPage = new Subject<string>();
  currentURL = window.location.href;
  page = this.currentURL.substring(this.currentURL.lastIndexOf('/') + 1);

  changePage(page: string) {
    this.page = page;
    this.currentPage.next(this.page);
  }
}